// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'

import VueResource from 'vue-resource'
import router from './router/index.js'
import App from './App'
import { store } from './store/store.js'
import VueQrcodeReader from 'vue-qrcode-reader'
import L from 'leaflet'
import draggable from 'vuedraggable'
import VueApexCharts from 'vue-apexcharts'
import 'leaflet/dist/leaflet.css'

export const eventBus = new Vue({
  data: {
    startLink: 'climbo-backend/v1/sectormap',
    preview: false,
    name: '',
    firstLine: '',
    imageUrl: '',
    noOfRoutes: '',
    mapX: 52.560,
    mapY: 13.380,
    testData: [],
    sectorInfo: false,
    routeInfo: false,
    bookInfo: false
  }
})

Vue.config.productionTip = false

Vue.use(VueMaterial)
Vue.use(VueResource)
Vue.use(VueQrcodeReader)
Vue.use(draggable)
Vue.use(VueApexCharts)

// process.env.BACKEND_URL is given through config/dev.env.js or config/prod.env.js respectively
Vue.http.options.root = process.env.BACKEND_URL

Vue.http.interceptors.push(function (request, next) {
  next((response) => {
    if (response.status === 500) {
       console.log('Error')
    }
    if (response.status === 401) {
      // console.log('this')
    }
  })
})

// setting on false no credentials vueResource
Vue.http.options.xhr = { withCredentials: false }

Vue.http.options.emulateJSON = true
Vue.http.options.emulateHTTP = true

Vue.component('apexchart', VueApexCharts)

Vue.material.registerTheme({
  default: {
    primary: {
      color: 'cyan',
      hue: 800,
      text: 'white'
    },
    accent: {
      color: 'pink',
      hue: 'A700'
    },
    warn: {
      color: 'pink',
      hue: 'A700',
      text: 'white'
    },
  },
  teal: {
    primary: 'white',
    accent: 'pink',
    warn: 'pink'
  },
  purple: {
    primary: 'cyan',
    accent: 'pink',
    warn: 'pink'
  },
  orange: {
    primary:'orange',
    accent: 'orange'
  }
})

Vue.filter('gradeFilter', function (value) {
  if ((value / 3) < (Math.round(value / 3))) {
    return (Math.round(value / 3)) + '-'
  } else if ((value / 3) > (Math.round(value / 3))) {
    return (Math.round(value / 3)) + '+'
  } else {
    return (Math.round(value / 3)).toString()
  }
})

Vue.filter('otherFilter', function (value) {
  if ((value) < (Math.round(value))) {
    return (Math.round(value)) + '-'
  } else if ((value) > (Math.round(value))) {
    return (Math.round(value)) + '+'
  } else {
    return (Math.round(value))
  }
})

Vue.filter('frenchFilter', function (value) {
  // console.log('store', store.state.routeColors)
  for (let i = 0; i < store.state.frenchValues.length; i++) {
    if (value === store.state.frenchValues[i].value) {
      return store.state.frenchValues[i].french
    }
  }
})

Vue.filter('attributesFilter', function (value) {
  var res = value.replace('strength', ' Kräftig')
  res = res.replace('long reach', ' Längenzüge')
  res = res.replace('pumped forearms', ' Pumpig')
  res = res.replace('technical', ' Technisch')
  return res
})

Vue.filter('roleFilter', function (value) {
  var res = value.replace('sectorManager', 'Administrator/in')
  res = res.replace('routeSetter', 'Routenschrauber/in')
  res = res.replace('climber', ' Climber')
  return res
})

Vue.filter('stylesFilter', function (value) {
  var res = value.replace('Beta flash', 'Flash')
  res = res.replace('Dog', 'Ausbouldern')
  res = res.replace('Following', 'Nachstieg')
  res = res.replace('Lead', 'Vorstieg')
  res = res.replace('Onsight flash', 'Onsight')
  res = res.replace('Redpoint', 'Rotpunkt')
  res = res.replace('2x Resting', '2x Sitzen')
  res = res.replace('Toprope', 'Toprope')
  return res
})

Vue.filter('skillsFilter', function (value) {
  var noSkills = value
  if (noSkills.length >= 1) {
    return '(' + (value.toString()) + ')'
  } else {
    return ''
  }
})

Vue.filter('geklettert', function (value) {
  if (value === 1) {
    return (value) + ' Route'
  } else {
    return (value + ' Routen')
  }
})

Vue.filter('colorText', function (value) {
  // console.log('store', store.state.routeColors)
  for (let i = 0; i < store.state.routeColors.length; i++) {
    if (value === store.state.routeColors[i].color) {
      return store.state.routeColors[i].name
    }
  }
})

Vue.filter('localdate', function (value) {
  var options = { year: 'numeric', month: '2-digit', day: '2-digit' }
  if (value === -1) {
    return ''
  } else {
    var dateTime = new Date(value)
    return dateTime.toLocaleDateString('de-DE', options)
  }
})

Vue.directive('colorRoute', {
  bind (el, binding) {
    if (binding.value == 'mixed') {
      el.style.background = 'url("../static/mixed_color.jpg") no-repeat 50% 50%'
      el.style.border = 'none'
    } else if (binding.value == 'white') {
      el.style.border = '1px solid grey'
      el.style.backgroundColor = binding.value
    } else {
      el.style.backgroundColor = binding.value
    }
  }
})

// Register a global custom directive called `v-focus`
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})

delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

/* eslint-disable no-new */
new Vue({
  store: store,
  router: router,
  el: '#app',
  render: h => h(App)
})
